'use strict'

import Axios from 'axios'
import { parseResponse, handleError } from '@/_helpers/utils.js'

export default {
  fetch (params) {
    return new Promise((resolve, reject) => {
      Axios.get('/1.0/spec-private/bat-personal-account/responses', {params})
        .then(response => {
          resolve(parseResponse(response))
        })
        .catch(err => reject(handleError(err)))
    })
  },
  fetchOne ({ id }) {
    return new Promise((resolve, reject) => {
      Axios.get(`/1.0/spec-private/bat-personal-account/responses/${id}`)
      .then(response => {
        resolve(parseResponse(response).data[0])
      })
        .catch(err => reject(handleError(err)))
    })
  }
}
